module.exports = __webpack_public_path__ + "static/media/home-insurance_640_color.4a0d9603.png";